export enum BrowserHistoryAction {
  Read = 'read',
  GoBack = 'goBack',
  GoForward = 'goForward',
}
